export default function render({
    text,
    id,
    parentQuestionOptionId = null,
}) {
  return `<div class="nhs-o-flex-column-items-start nhs-u-gap--600 nhs-u-width--full" data-question-section 
                ${parentQuestionOptionId ? `data-parent-question-option-id="${parentQuestionOptionId}" hidden` : ''}>
            <fieldset class="nhs-u-width--full">
                <legend class="nhs-c-heading--black-1000-sans-subhead-1-large-medium nhs-u-margin--bottom-600">${text}
                </legend>
                <ul class="nhs-c-wrapper--column-gap-600 nhs-c-wrapper__panel-filter-group nhs-c-wrapper__panel-filter-group--column" 
                    data-group="" data-self-guided-tour-question-options-list-${id}>
                </ul>
            </fieldset>
        </div>`;
}